import { watch, ref } from "vue";
import { postMatchChampionList } from "@/api/home-page";
// config
import { championshipPC } from "@/config/homePage";

export function getCurrentRaceType(saiji) {
  let current = new Date().getTime();
  if (
    championshipPC[saiji][0].startDate <= current &&
    championshipPC[saiji][1].startDate > current
  ) {
    return 0;
  } else if (
    championshipPC[saiji][1].startDate <= current &&
    championshipPC[saiji][2].startDate > current
  ) {
    return 1;
  } else if (championshipPC[saiji][2].startDate <= current) {
    console.log(championshipPC[saiji][2].startDate)
    console.log(current)
    return 2;
  } else {
    return 0;
  }
}

function useHomePageChampionship(homePageState, active, isPc) {
  const firstHalf = ref([]);
  const secondHalf = ref([]);
  const curPage = ref(1);
  // 用于记录页码是不是已经请求过
  const pageCache = ref([]);
  const battleList = ref([]);

  const battleLenMap = {
    0: 8,
    1: 8,
    2: 2,
  };

  const _completeNextLevelData = (levelData) => {
    const dataArr = [];
    for (let i = 0; i < levelData.length; i++) {
      const item = levelData[i];
      // 填充 红队 数据，否则填充 蓝队 数据
      if (i % 2 === 0) {
        const newItem = {
          // 这里给个假的 id，目的是为了让赛事图展示完全
          // 因为赛事会出现还没有进行比赛的情况
          red_match_team_id: -1,
          blue_match_team_id: -1,
        };
        // 红队获胜
        if (
          item.victory_match_team_id &&
          item.victory_match_team_id === item.red_match_team_id
        ) {
          newItem.red_match_team = item.red_match_team;
          newItem.red_match_team_id = item.red_match_team_id;
          newItem.red_match_team_name = item.red_match_team_name;
          newItem.red_match_team_score = item.red_match_team_score;
        }
        // 蓝队获胜
        if (
          item.victory_match_team_id &&
          item.victory_match_team_id === item.blue_match_team_id
        ) {
          newItem.red_match_team = item.blue_match_team;
          newItem.red_match_team_id = item.blue_match_team_id;
          newItem.red_match_team_name = item.blue_match_team_name;
          newItem.red_match_team_score = item.blue_match_team_score;
        }
        dataArr.push(newItem);
      } else {
        const groupItem = dataArr[dataArr.length - 1];
        // 红队获胜
        if (
          item.victory_match_team_id &&
          item.victory_match_team_id === item.red_match_team_id
        ) {
          groupItem.blue_match_team = item.red_match_team;
          groupItem.blue_match_team_id = item.red_match_team_id;
          groupItem.blue_match_team_name = item.red_match_team_name;
          groupItem.blue_match_team_score = item.red_match_team_score;
        }
        // 蓝队获胜
        if (
          item.victory_match_team_id &&
          item.victory_match_team_id === item.blue_match_team_id
        ) {
          groupItem.blue_match_team = item.blue_match_team;
          groupItem.blue_match_team_id = item.blue_match_team_id;
          groupItem.blue_match_team_name = item.blue_match_team_name;
          groupItem.blue_match_team_score = item.blue_match_team_score;
        }
      }
    }
    return dataArr;
  };

  /**
   * 格式化数据
   * @param {*} original 原数据
   * @param {*} finals 是否是总决赛
   * @param {*} battleLen 对战数量
   * @returns
   */
  const _normalizeChampionshipData = (original, finals = false, battleLen) => {
    let [list, list_two, list_three] = original;
    const ret = [];

    // 补全数据一级数据
    if (!list?.length && battleLen) {
      const emptyArr = Array.from(new Array(battleLen * 2), () => ({}));
      list = _completeNextLevelData(emptyArr);
    }

    // 补全数据二级数据
    if (!finals && list?.length && !list_two?.length) {
      list_two = _completeNextLevelData(list);
    }

    // 如果不是总决赛（64进16、16进4），需要自己从 list_two 找到 list_three 数据
    if (!finals && list_two?.length) {
      list_three = _completeNextLevelData(list_two);
    }

    const createTeamItem = (record) =>
      record.map((item) => {
        // 还未开打的，不展示比分
        const notStarted =
          item.red_match_team_score === 0 && item.blue_match_team_score === 0;
        return {
          id: item.id,
          winner: item.victory_match_team_id,
          redTeam: {
            name: item.red_match_team_name,
            teamId: item.red_match_team_id,
            wins: !notStarted ? item.red_match_team_score : "",
            members: Array.isArray(item.red_match_team?.match_player_info)
              ? item.red_match_team.match_player_info
              : [],
            teamZoomName: item.red_match_team?.victory_match_team_service_name
              ? item.red_match_team.victory_match_team_service_name
              : "",
          },
          blueTeam: {
            name: item.blue_match_team_name,
            teamId: item.blue_match_team_id,
            wins: !notStarted ? item.blue_match_team_score : "",
            members: Array.isArray(item.blue_match_team?.match_player_info)
              ? item.blue_match_team.match_player_info
              : [],
            teamZoomName: item.blue_match_team?.victory_match_team_service_name
              ? item.blue_match_team.victory_match_team_service_name
              : "",
          },
        };
      });

    if (list?.length) {
      ret.push(createTeamItem(list));
    }
    if (list_two?.length) {
      ret.push(createTeamItem(list_two));
    }
    if (list_three?.length) {
      ret.push(createTeamItem(list_three));
    }
    return ret;
  };

  /**
   * 获取冠军赛列表
   * @param session 场次：1第一轮初赛，2第一轮复活赛，3第二轮初赛，4第二轮复活赛
   * @param zone 赛区：1是甲区， 2是甲区，3是丙区，4是丁区
   */
  const fetchChampionshipList = async (session, zone) => {
    console.log("session===>", session);
    try {
      const res = await postMatchChampionList({
        matchGroup: homePageState.groupType,
        matchSeason: homePageState.raceQuartertype,
        matchSession: session,
        matchZone: zone,
      });
      if (res.code === 0) {
        if (res.data.list.length === 0) {
          homePageState.isNone = true;
        } else {
          homePageState.isNone = false;
        }
        return res.data;
      }
    } catch (error) {
      console.warn("获取冠军赛列表失败", error);
    }
    return {};
  };

  /**
   * 是否是 16进4、总决赛
   * @param session 场次：0：64进16，1：16进4， 2：总决赛
   * @returns
   */
  const isPreliminaries = (session) => ![0].includes(session);

  /**
   * 获取上半场数据
   * @param {*} zone 赛区：1是甲区， 2是甲区，3是丙区，4是丁区
   */
  const loadFirstHalfData = async (zone = 1) => {
    const res = await fetchChampionshipList(active.value + 1, zone);
    if (res.list) {
      const isFinals = active.value === 2;
      const normalized = _normalizeChampionshipData(
        res.list,
        isFinals,
        battleLenMap[active.value]
      );

      firstHalf.value = normalized;
    } else {
      firstHalf.value = [];
    }
  };

  /**
   * 获取下半场数据
   * @param {*} zone 赛区：1是甲区， 2是甲区，3是丙区，4是丁区
   */
  // const loadSecondHalfData = async (zone = 2) => {
  //   const res = await fetchChampionshipList(active.value + 1, zone);
  //   if (res.list) {
  //     const normalized = _normalizeChampionshipData(res.list);
  //     secondHalf.value = normalized;
  //   } else {
  //     secondHalf.value = [];
  //   }
  // };

  const handlePaginationChange = (page) => {
    curPage.value = page;
  };

  /**
   * 获取对战列表
   * @param {*} zone 赛区：1是甲区， 2是甲区，3是丙区，4是丁区
   */
  const loadBattleList = async (zone) => {
    // 不再请求
    if (pageCache.value.includes(zone)) {
      return;
    }
    pageCache.value.push(zone);
    const res = await fetchChampionshipList(active.value + 1, zone);
    if (res.list) {
      const normalized = _normalizeChampionshipData(
        res.list,
        false,
        battleLenMap[0]
      );
      battleList.value[zone - 1] = normalized;
    } else {
      battleList.value[zone - 1] = [];
    }
  };

  watch(
    [
      () => homePageState.raceQuartertype,
      () => homePageState.groupType,
      () => homePageState.raceType,
      () => active.value,
    ],
    () => {
      if (isPreliminaries(active.value)) {
        loadFirstHalfData();
      }
      if (!isPreliminaries(active.value)) {
        battleList.value = [];
        curPage.value = 1;
        pageCache.value = [];
        loadBattleList(1);
        loadBattleList(2);
      }
    },
    { immediate: true }
  );

  watch(
    () => curPage.value,
    () => {
      if (isPc) {
        loadBattleList(3);
        loadBattleList(4);
      }

      // 移动端逻辑处理
      if (!isPc && !isPreliminaries(active.value)) {
        loadBattleList(curPage.value);
      }
    }
  );

  return {
    fetchChampionshipList,
    firstHalf,
    secondHalf,
    isPreliminaries,
    handlePaginationChange,
    curPage,
    battleList,
    getCurrentRaceType,
  };
}

export default useHomePageChampionship;
